module.exports = __webpack_public_path__ + "img/lego-bg.5885e1ac.jpg";